export enum AlertDefinitionKey {
  // Main Hoist related
  MAIN_HOIST_1_SENSOR_ERROR = "MAIN_HOIST_1_SENSOR_ERROR",
  MAIN_HOIST_2_SENSOR_ERROR = "MAIN_HOIST_2_SENSOR_ERROR",
  MAIN_HOIST_DRIVE_ERROR = "MAIN_HOIST_DRIVE_ERROR",
  MAIN_HOIST_BRAKE_ERROR = "MAIN_HOIST_BRAKE_ERROR",
  MAIN_HOIST_OVERLOAD = "MAIN_HOIST_OVERLOAD",
  MAIN_HOIST_BLOCK_POSITION_PRE_HIGH = "MAIN_HOIST_BLOCK_POSITION_PRE_HIGH",
  MAIN_HOIST_BLOCK_POSITION_HIGH = "MAIN_HOIST_BLOCK_POSITION_HIGH",

  // Boom Hoist related
  BOOM_HOIST_SENSOR_ERROR = "BOOM_HOIST_SENSOR_ERROR",
  BOOM_HOIST_DRIVE_ERROR = "BOOM_HOIST_DRIVE_ERROR",
  BOOM_HOIST_BRAKE_ERROR = "BOOM_HOIST_BRAKE_ERROR",
  BOOM_HOIST_ANGLE_ERROR = "BOOM_HOIST_ANGLE_ERROR",

  // Slewing related
  SLEWING_DRIVE_ERROR = "SLEWING_DRIVE_ERROR",
  SLEWING_BRAKE_ERROR = "SLEWING_BRAKE_ERROR",
  SLEWING_ANGLE_ERROR = "SLEWING_ANGLE_ERROR",

  // Auxiliary Hoist related
  AUX_HOIST_SENSOR_ERROR = "AUX_HOIST_SENSOR_ERROR",
  AUX_HOIST_DRIVE_ERROR = "AUX_HOIST_DRIVE_ERROR",
  AUX_HOIST_BRAKE_ERROR = "AUX_HOIST_BRAKE_ERROR",

  // Load Tugger related
  LOAD_TUGGER_11_ERROR = "LOAD_TUGGER_11_ERROR",
  LOAD_TUGGER_21_ERROR = "LOAD_TUGGER_21_ERROR",

  // Sling Hoist related
  SLING_HOIST_ERROR = "SLING_HOIST_ERROR",

  // EPU (Electrical Power Unit) related
  EPU_POWER_ERROR = "EPU_POWER_ERROR",
  EPU_VOLTAGE_ERROR = "EPU_VOLTAGE_ERROR",

  // Network related
  NETWORK_COMMUNICATION_ERROR = "NETWORK_COMMUNICATION_ERROR",
  NETWORK_CONFIG_ERROR = "NETWORK_CONFIG_ERROR",

  // Safety related
  E_STOP_ERROR = "E_STOP_ERROR",
  BRAKE_FAILURE = "BRAKE_FAILURE",
  OVERLOAD_PROTECTION = "OVERLOAD_PROTECTION",

  // Environmental
  HIGH_WIND_SPEED = "HIGH_WIND_SPEED",
  TEMPERATURE_ERROR = "TEMPERATURE_ERROR",
  VENTILATION_ERROR = "VENTILATION_ERROR",

  // General
  GENERAL_SENSOR_ERROR = "GENERAL_SENSOR_ERROR",
  GENERAL_SYSTEM_ERROR = "GENERAL_SYSTEM_ERROR",

  // From UI mocks
  TROLLEY_2_WINCH_DISABLED = "TROLLEY_2_WINCH_DISABLED",
  TACKLE_2_BRAKE_OIL_FILTER_CLOGGED = "TACKLE_2_BRAKE_OIL_FILTER_CLOGGED",
  AUX_HOIST_OIL_LEVEL_LOW = "AUX_HOIST_OIL_LEVEL_LOW",
  MAIN_HOIST_DRUM_ROPE_LAYER_UNEVEN = "MAIN_HOIST_DRUM_ROPE_LAYER_UNEVEN",
  MAIN_HOIST_BRAKE_FILTER_BLOCKED = "MAIN_HOIST_BRAKE_FILTER_BLOCKED",
  AUX_HOIST_DRUM_SLACK_DETECTED = "AUX_HOIST_DRUM_SLACK_DETECTED",
}

export enum CraneActionKey {
  HOISTING_UP = "hoisting_up",
  HOISTING_DOWN = "hoisting_down",
  BOOMING_UP = "booming_up",
  BOOMING_DOWN = "booming_down",
  PERSONNEL_LIFT = "personnel_lift",
  STOPPING = "stopping",
  STARTING = "starting",
  SLEWING_LEFT = "slewing_left",
  SLEWING_RIGHT = "slewing_right",
  TUGGER_IN = "tugger_in",
  TUGGER_OUT = "tugger_out",
}
